import { Directive, Input, Output, EventEmitter, NgZone, OnInit } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[appScrollListener]'
})
export class ScrollListenerDirective implements OnInit {
    @Input() target: string;
    @Output() scrollFired = new EventEmitter<Event>();

    constructor(private ngZone: NgZone) { }

    ngOnInit() {
        const element = document.getElementsByClassName(this.target);
        if (element.length > 0) {
            element[0].addEventListener('scroll', this.onScrollEvent, true);
            this.ngZone.runOutsideAngular(() => {
                element[0].addEventListener('scroll', this.onScrollEvent, true);
            });
        }
    }

    onScrollEvent = (event: Event): void => {
        this.ngZone.run(() => {
            this.scrollFired.emit(event);
        });
    }
}
